<div class="nxt-title d-flex justify-content-between align-items-center">
    <span>{{value }} </span>
    <span *ngIf="rowData?.lastChannelId != 0" [ngbTooltip]="value+' fallback'" class="nxticon-channel_deflector nxt-font-25 posi"></span>
</div>